import { Body, Box, Link } from '@hover/blueprint';
import type { ReactNode } from 'react';
import React from 'react';

import { Partner } from 'src/modules/designStudio/helpers/Partner';
import { usePartner } from 'src/modules/designStudio/hooks';
import { Mode } from 'src/modules/designStudio/providers';
import { useIsLandscape, useMode, useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

const testId = 'powered-by-hover';

const LinkOrBoldText = ({ children }: { children: ReactNode }) => {
  const partner = usePartner();
  return (
    <Body color="primary.600" fontWeight="600" size={300}>
      {partner === Partner.DEFAULT ? (
        <Link href="/" isExternal style={{ textDecoration: 'underline' }}>
          {children}
        </Link>
      ) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>{children}</>
      )}
    </Body>
  );
};

const PoweredByHover = () => {
  const mode = useMode();
  const [isLandscape] = useIsLandscape();
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  if (mode !== Mode.GUEST || isLandscape) {
    return null;
  }
  return (
    <Box alignSelf="center" testId={testId}>
      <Body color="neutral.500" marginRight="100" size={300}>
        {t('guest.poweredBy')}
      </Body>
      <LinkOrBoldText>HOVER</LinkOrBoldText>
    </Box>
  );
};

export { PoweredByHover, testId };
